/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowDownLeftFromCircle = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M2 12a10 10 0 1 1 10 10" }],
    ["path", { d: "m2 22 10-10" }],
    ["path", { d: "M8 22H2v-6" }]
  ]
];

export { ArrowDownLeftFromCircle as default };
//# sourceMappingURL=arrow-down-left-from-circle.js.map
